exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bottom-filters .btn {\n  margin-bottom: 0 !important;\n}", ""]);

// exports
